import { SetUpAutoshipDetails } from '@libs/shared-ui';

import { type FormFields, usePurchaseFormWatch } from '@/entities/purchase-form';

export const AutoshipDetails = () => {
    const deliveryMethod: FormFields['fulfilmentMethod'] | undefined = usePurchaseFormWatch('fulfilmentMethod');

    return <SetUpAutoshipDetails fulfillmentMethod={deliveryMethod ?? 'bopis'} />;
};
